export const setMemberShipRadio = [
    {
        label: "Standard Member",
        memberType: "member",
    },
    {
        label: "Premimum Member",
        memberType: "premimum",
    },
    {
        label: "Silver Member",
        memberType: "silver",
    },
    {
        label: "Gold Member",
        memberType: "gold",
    },
];
